"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlatButton = void 0;

var _styles = require("./styles");

var _styledTools = require("styled-tools");

var _styles2 = require("react-components/styles");

var _typographyStyles = require("../typography/typography-styles");

var _link = _interopRequireDefault(require("../links/link"));

var _routerLink = _interopRequireDefault(require("../links/router-link"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Export `FlatButton` styled component.
 */
var FlatButton = (0, _styledComponents["default"])(_link["default"]).attrs(function (_ref) {
  var as = _ref.as,
      href = _ref.href,
      responsive = _ref.responsive,
      size = _ref.size,
      to = _ref.to;
  var element = as || to && _routerLink["default"] || href && 'a' || 'button';
  return {
    as: element,
    responsive: responsive !== null && responsive !== void 0 ? responsive : true,
    size: size || 'small',
    type: element === 'button' ? 'button' : undefined
  };
}).withConfig({
  displayName: "flat-button__FlatButton",
  componentId: "sc-wsend3-0"
})(["appearance:none;background-color:transparent;display:inline-block;font-family:", ";padding:0;", ";", ""], _typographyStyles.typography.fontFamilies.saira, (0, _styledTools.switchProp)('size', {
  large: (0, _styledComponents.css)(["", " ", ""], _styles.buttonFontSizes.large, _styles2.media.max('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n      "])), (0, _styledTools.ifProp)('responsive', _styles.buttonFontSizes.small))),
  medium: (0, _styledComponents.css)(["font-size:16px;font-weight:500;letter-spacing:-0.2px;line-height:21px;"]),
  small: (0, _styledComponents.css)(["font-size:13px;font-weight:500;letter-spacing:normal;line-height:20px;"])
}), (0, _styledTools.ifProp)('fullWidth', (0, _styledComponents.css)(["text-align:center;width:100%;"])));
exports.FlatButton = FlatButton;